var lib_core = require("lib-core");
var SymbolSettingsStateMachine = require("./symbolSettingsStateMachine.js");
var SymbolSettingsView         = require("./symbolSettingsView.js");
var SymbolSettingsModel 	   = require("./symbolSettingsModel.js");

var SymbolSettingsController = function(archLayers, dependencies, configuration) {
    ui_extensions.SettingsController.call(this, archLayers, dependencies, configuration);
};

var showUI = lib_core.showUI();
if(showUI) {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(SymbolSettingsController, ui_extensions.SettingsController);
}
if(showUI) {
    SymbolSettingsController.inject = {
        tabController : ui_extensions.TabController
    };
} else {
    SymbolSettingsController.inject = {};
}

module.exports = SymbolSettingsController;

SymbolSettingsController.prototype.createStateMachine = function () {
    return new SymbolSettingsStateMachine(this.root, this.getModel());
};

SymbolSettingsController.prototype.createView = function () {
    var parentView = this.tabController.getView();
    return new SymbolSettingsView(this.getModel(), this.getStatemachine(), parentView, this.configuration);
};

SymbolSettingsController.prototype.createModel = function () {
    return new SymbolSettingsModel(this.getData());
};
